const $dropdownClose = $(".js-dropdown-close");
const $win = $(window);

if ($win.width() > 1024) {
  $(".dropdown").on("mouseover", function () {
    const $this = $(this);
    $this.closest("li").find(".js-dropdown-trigger").addClass("is-hovered");
  });

  $(".dropdown").on("mouseleave", function () {
    const $this = $(this);
    $this.closest("li").find(".js-dropdown-trigger").removeClass("is-hovered");
  });
}

if ($win.width() < 1024) {
  $(".js-dropdown-trigger").on("click", function (event) {
    const $this = $(this);

    if (!$this.hasClass("is-active")) {
      event.preventDefault();
    }

    $this.closest("li").find(".dropdown").toggleClass("is-active");
    $this.toggleClass("is-active");
  });
}

/**
 * Dropdown Close
 *
 * @return {Void}
 */
$dropdownClose.on("click", function () {
  const $dropdown = $(this).closest(".dropdown");
  $dropdown.removeClass("is-active");
  $dropdown.closest("li").find(".js-dropdown-trigger").removeClass("is-active");
});

/**
 * Dropdown trigger level 2
 *
 * @return {Void}
 */
if ($win.width() < 1024) {
  $(".js-dropdown-trigger-level-2").on("click", function (event) {
    const $this = $(this);

    if (!$this.hasClass("is-active")) {
      event.preventDefault();
    }

    $this.closest("li").find("ul").slideToggle();
    $this.toggleClass("is-active");
  });
}
